module.exports = __webpack_public_path__ + "static/media/fold3.357ccd9f.jpg";